<!--
  2021-09-29 C007 实现新的Landing模板
-->
<template>
  <div style="overflow-y: scroll">
    <img :src="download" class="downloader" @click="downloadApp"/>
    <img
      src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/landing/landing20230320.png"
      style="width: 100%; display: block; padding: 0 0 0 0"
    />
  </div>
</template>

<script>
import download from '@/assets/images/landing/header.png'
import {LogUtils} from '@/utils'
export default {
  name: 'Template2',
  data () {
    return {
      download
    }
  },
  mounted () {
    this.downloadApp()
  },
  methods: {
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    }
  }
}
</script>

<style lang="less">
#app {
  #viewContainer {
    padding-bottom: 0px;

    .downloader{
      opacity: 0.9;
      position: fixed;
      height: 76px;
      top: 0;
      left: 0;
      width: 100vw;
      z-index: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing/template3.vue